'use strict';

$ = jQuery;

/*
Conta o número de exibições da oferta
*/
dataLayer.push({
  'ecommerce': {
    'detail': {
      'products': [{
        'name': $('.jc-offer-header').data('name'),
        'id': $('.jc-offer-header').data('id'),
        'brand': $('.jc-offer-header').data('brand')
      }]
    }
  }
});
//TODO evento ecommerce

/*
Conta o número de cliques no botão de submit do formulário.
A contagem acontece independentemente do envio do lead.
*/
$(document).on('click', '#offer-submit', function () {
  dataLayer.push({
    'event': 'ga_event',
    'eventCategory': 'Oferta',
    'eventAction': 'Clique - Botão formulário',
    'eventLabel': $(this).text()
  });

  gtag('event', 'Oferta', {
    'eventAction': 'Clique - Botão formulário',
    'eventLabel': $(this).text()
  });
});